import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.paper)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        (_ctx.paper.doi)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createElementVNode("a", {
                class: "underline hover:no-underline",
                target: "_blank",
                href: `https://doi.org/${_ctx.paper.doi}`
              }, "Publisher", 8, _hoisted_3),
              _hoisted_4,
              _createElementVNode("a", {
                class: "underline hover:no-underline",
                target: "_blank",
                href: `https://libkey.io/${_ctx.paper.doi}?utm_source=inciteful`
              }, "Full Text from LibKey", 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}